


import React, {
    useEffect,
    useRef,
    useState,
} from "react";
import { GetProducts, GetProductsByCategoryId } from '../utils/product';//באמצעות הפונקציה יביא רשימה של מוצרים
import { setProducts, setProductsByCategory } from '../features/productsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Typography, Box, Stack, Grid, Button } from "@mui/material";
import Categories from './categories';
import { useParams } from 'react-router-dom';
// import { setProductsPage, setCurrentPage } from '../../actions/productsActions';
import { useNavigate } from 'react-router-dom';
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import SingleProductDesktop from "./SingleProductDesktop";
import CircularProgress from '@mui/material/CircularProgress';
import ProductList from "./ProductList";
import Search from './Search';
import { clearSearch } from "../features/searchSlice";
import { setSelectedCategoryId } from "../features/categoriesSlice"; // אם יש לך



export default function Products() {
    const productsTopRef = useRef(null);

    useEffect(() => {
        // כניסה למסך מוצרים: להציג הכל מחדש
        dispatch(clearSearch());
        // אופציונלי: גם לאפס קטגוריה
        dispatch(setSelectedCategoryId(-1));
        setCurrentPage(1);
    }, []);

    // שימוש בשתנה של מערך מוצרים ששמרנו בחלק של המוצרים בסלייס
    const products = useSelector(state => state.product.products);
    const logedUser = useSelector(state => state.user.logedUser);
    const selectedCategoryId = useSelector(state => state.categries.selectedCategoryId);
    const searchTerm = useSelector(state => state.search.searchTerm);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 24;
    const [loading, setLoading] = useState(false);



    console.log('searchTerm', searchTerm);

    // const productsByCategory = useSelector(state => state.product.GetProductsByCategoryId);
    //  const productsView = productsByCategory?.length > 0 ? productsByCategory: products;
    const dispatch = useDispatch();
    // const navigate = useNavigate();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down("md"));

    //  const handleOrderClick = () => {
    //      navigate('/order');
    //  };


    //  //  השם חייב להיות תואם למה שהגדרנו בApp.js - products/:categoryId
    // const { categoryId } = useParams();

    //שליפת נתונים: בפונקציה GetProductsList, לאחר שליפת המוצרים מהשרת, אנו מוסיפים לכל מוצר את שדה outOfStock על בסיס הכמות.
    // const GetProductsList = async () => {
    //     const data = await GetProducts();
    //     // Adding outOfStock property based on quantity
    //     const updatedData = data.map(product => ({
    //         ...product,
    //         id: product.id ?? product.ID,   // 🔑 מאחדים מזהה קבוע
    //         outOfStock: product.quantity === 0
    //     }));
    //     dispatch(setProducts(updatedData));
    // }

    const GetProductsList = async () => {
        try {
            setLoading(true);

            const categoryIdToSend = selectedCategoryId === -1 ? undefined : selectedCategoryId;

            const data = await GetProducts({
                categoryId: categoryIdToSend,
                searchTerm: searchTerm?.trim() || undefined,
                page: currentPage,
                pageSize,
            });

            const updatedItems = (data.items || []).filter(Boolean).map((product, idx) => ({
                ...product,
                id: product.id ?? product.ID ?? product.Id ?? idx,
                outOfStock:
                    product.isInStock === false ||
                    product.IsInStock === false ||
                    product.quantity === 0
            }));

            dispatch(setProducts(updatedItems));
            setTotalPages(data.totalPages ?? 1);
        } finally {
            setLoading(false);
        }
    };




    // useEffect(() => {
    //     GetProductsList()        // קריאה ל־API לקבל את המוצרים  
    // }, []);




    useEffect(() => {
        GetProductsList();
    }, [currentPage, selectedCategoryId, searchTerm]);
    useEffect(() => {
        productsTopRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    }, [currentPage]);

    useEffect(() => {
        setCurrentPage(1);
    }, [selectedCategoryId, searchTerm]);






    //טיפול בתרחיש שבו המוצרים עדיין נשלפים מה-API
    //מאפשר להציג הודעת טעינה לפני שליפת המוצרים ועיבודם במסך
    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" sx={{ p: 4 }}>
                <CircularProgress size={30} sx={{ mr: 5 }} />
                <Typography variant="h4" sx={{ mr: 5 }}>טוען מוצרים</Typography>
            </Box>
        );
    }

    if (!loading && products?.length === 0) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" sx={{ p: 4 }}>
                <Typography variant="h5">לא נמצאו מוצרים</Typography>
            </Box>
        );
    }


    return (
        <>
            {/* <Search /> */}
            {/* <ProductList></ProductList> */}
            <Box
                ref={productsTopRef}
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    py: {
                        xs: 3,
                        md: 6,
                    },
                    px: 1,
                    scrollMarginTop: {
                        xs: "80px",
                        md: "120px",
                    },
                }}
            >
                <Typography
                    component="h1"
                    sx={{
                        fontSize: {
                            xs: "1.5rem",
                            sm: "1.8rem",
                            md: "2.125rem",
                        },
                        fontWeight: 700,
                        textAlign: "center",
                    }}
                >
                    כלל המוצרים שלנו:
                </Typography>
            </Box>
            {/* {logedUser?.tipeUser == "admin" && <Button>הוסף מוצר</Button>} */}


            {/* <Box display="flex" justifyContent="center" sx={{ p: 4 }}>
                {Array.from({ length: totalPages }, (_, index) => (
                    <Button
                        key={index}
                        onClick={() => handlePageChange(index + 1)}
                        disabled={index + 1 === currentPage}
                    >
                        {index + 1}
                    </Button>
                ))}
        </Box> */}

            <Container
                maxWidth="xl"
                sx={{
                    px: {
                        xs: 1,
                        sm: 2,
                        md: 3,
                    },
                }}
            >
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "repeat(2, minmax(0, 1fr))",
                            sm: "repeat(3, minmax(0, 240px))",
                            md: "repeat(4, minmax(0, 252px))",
                        },
                        gap: {
                            xs: 1,
                            sm: 1.5,
                            md: 1.5,
                        },
                        justifyContent: "center",
                        alignItems: "stretch",
                        width: "100%",
                    }}
                >
                    {products
                        .filter(Boolean)
                        .map((product, idx) => (
                            <Box
                                key={
                                    product.id ??
                                    product.ID ??
                                    product.Id ??
                                    `${product.name}-${product.categoryId}-${idx}`
                                }
                                sx={{
                                    width: "100%",
                                    minWidth: 0,
                                    display: "flex",
                                }}
                            >
                                <SingleProductDesktop
                                    product={product}
                                    matches={matches}
                                />
                            </Box>
                        ))}
                </Box>
                <Box
                    sx={{
                        mt: {
                            xs: 3,
                            md: 4,
                        },
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: {
                            xs: 1,
                            sm: 2,
                        },
                    }}
                >
                    <Button
                        variant="outlined"
                        disabled={currentPage <= 1}
                        onClick={() =>
                            setCurrentPage((page) => page - 1)
                        }
                    >
                        הקודם
                    </Button>

                    <Typography
                        sx={{
                            fontSize: {
                                xs: "0.9rem",
                                sm: "1rem",
                            },
                        }}
                    >
                        עמוד {currentPage} מתוך {totalPages}
                    </Typography>

                    <Button
                        variant="outlined"
                        disabled={currentPage >= totalPages}
                        onClick={() =>
                            setCurrentPage((page) => page + 1)
                        }
                    >
                        הבא
                    </Button>
                </Box>
            </Container>
        </>
    );
};


